module.exports = __webpack_public_path__ + "5d42b31d59d187dccda152cb5fb00d58.pdf";